import React from 'react';

function EmptySearch() {
  return (
    <svg width="67" height="77" viewBox="0 0 67 77" xmlns="http://www.w3.org/2000/svg">
      <g
        id="Active-Devices---Empty-Search"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Active-Devices---Empty" transform="translate(-861 -317)">
          <g id="Group" transform="translate(862 318)">
            <path
              d="M25 64H2a2 2 0 01-2-2V2a2 2 0 012-2h31a2 2 0 011.6.8l11 14.667a2 2 0 01.4 1.2V32"
              id="Path"
              stroke="#C3CAD6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Path-11"
              stroke="#8008f7"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M54 64l11 11"
            />
            <path
              d="M21 56h-9a4 4 0 01-4-4V30a4 4 0 014-4h18a4 4 0 014 4v2"
              id="Path"
              stroke="#C3CAD6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              id="Oval"
              stroke="#8008f7"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              cx="42"
              cy="52"
              r="16"
            />
            <path
              d="M43.168 56.216c.16 0 .24-.08.24-.24v-.768c0-.4.044-.72.132-.96.088-.24.252-.52.492-.84L45.64 51.2c.416-.56.724-1.076.924-1.548.2-.472.3-.996.3-1.572 0-.592-.104-1.14-.312-1.644a3.673 3.673 0 00-.888-1.296 4.072 4.072 0 00-1.38-.84 5.01 5.01 0 00-1.764-.3c-1.248 0-2.268.348-3.06 1.044-.792.696-1.276 1.62-1.452 2.772-.032.144.032.232.192.264l1.512.264c.144.032.232-.032.264-.192.144-.736.428-1.3.852-1.692.424-.392.972-.588 1.644-.588.688 0 1.248.2 1.68.6.432.4.648.944.648 1.632 0 .208-.02.4-.06.576-.04.176-.104.36-.192.552-.088.192-.204.4-.348.624-.144.224-.32.48-.528.768l-1.608 2.208c-.256.352-.44.68-.552.984-.112.304-.168.696-.168 1.176v.984c0 .16.08.24.24.24h1.584zm.12 4.368c.16 0 .24-.08.24-.24V58.28c0-.16-.08-.24-.24-.24h-1.824c-.16 0-.24.08-.24.24v2.064c0 .16.08.24.24.24h1.824z"
              id="?"
              fill="#8008f7"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EmptySearch;
